// extracted by mini-css-extract-plugin
module.exports = {"grid":"faculty-module--grid--13F4E"};